import { Component, Input, OnInit } from '@angular/core';

import { FilterTypeAutoTaggingTopicsCheckboxModel,
    TaggingEnum} from '../../models/filter-type-auto-tagging-topics-checkbox.model';
import { FilterCheckboxesComponent } from '../../components/filterCheckboxes/filter-checkboxes.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { IncludeExcludeEnum } from '../../enums/include-exclude.enum';
import { ChipModel } from '../../../Forms/models/chip.model';




@Component({
    selector: 'agpr-auto-tagging-topics-checkbox-filter',
    templateUrl: './auto-tagging-topics-checkbox-filter.component.html',
    styleUrls: [
        '../../../../Common/Filter/components/filterCheckboxes/filter-checkboxes.component.scss',
        './auto-tagging-topics-checkbox-filter.component.scss'
    ],
    standalone: false
})
export class AutoTaggingTopicsCheckboxFilterComponent extends FilterCheckboxesComponent implements OnInit {
    @Input() declare filter: FilterTypeAutoTaggingTopicsCheckboxModel;

    readonly buttonTypes = ButtonTypesEnum;
    readonly taggingIncludeExcludeEnum = IncludeExcludeEnum;
    readonly taggingEnum = TaggingEnum;
    readonly ALL_AUTO_TAGGING_TOPICS_CHIPS: ChipModel = {
        id: TaggingEnum.auto,
        label: 'Monitoring.filter.tagging.allAutoTaggingTopics'
    };
    readonly ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS: ChipModel = {
        id: TaggingEnum.onDemand,
        label: 'Monitoring.filter.tagging.allOnDemandTopics'
    };

    addCustom(): void {}

    ngOnInit(): void {
        this.refresh();
    }

    autoTagOptionsChanged() {
        if (this.filter.autoTagOptions.length === 0) {
            this.filter.removeCurrentChip(this.ALL_AUTO_TAGGING_TOPICS_CHIPS);
            this.filter.removeCurrentChip(this.ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS);
            this.value = [];
        }
        this.handleChange();
    }
}
